<template>
  <gf-button
    variant="secondary"
    :after-icon="subscribtionIcon"
    :text="subscribtionText"
    :show-only-icon-mobile="true"
    @click="onSubscribtionButtonClick"
  />
</template>

<script>
import UserService from '@shared/modules/user/user.service';
import ProfileMessages from '@shared/modules/profile/profile.messages';
import GfButton from '@/shared-modules/shared-components/shared/components/GfButton';

export default {
  name: 'GfButtonSubscribeUser',
  components: { GfButton },
  props: {
    isSubscribed: {
      default: false
    },
    username: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      isSubscribedModel: false
    };
  },
  computed: {
    subscribtionIcon() {
      if (this.isSubscribedModel) return 'gf-icon gf-icon-check';
      return 'gf-icon gf-icon-plus';
    },
    subscribtionText() {
      if (this.isSubscribedModel) return this.$t('profile.isSubscribed');
      return this.$t('profile.subscribe');
    },
    isUserAuthtorized() {
      return this.$store.getters.getIsUserAuthtorized;
    }
  },
  mounted() {
    if (typeof this.isSubscribed === 'string') {
      this.isSubscribedModel = this.isSubscribed === 'true';
    } else {
      this.isSubscribedModel = this.isSubscribed;
    }
  },
  methods: {
    onSubscribtionButtonClick() {
      if (this.isUserAuthtorized) {
        const followMethod = this.isSubscribedModel
          ? UserService.unfollowUser
          : UserService.followUser;
        followMethod(this.username).then(() => {
          this.isSubscribedModel = !this.isSubscribedModel;
        });
      } else {
        window.location = '/auth/login';
      }
    }
  },
  i18n: {
    messages: ProfileMessages
  }
};
</script>
